import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { DoctorLicencePricingManagement } from "./DoctorLicencePricingManagement";
import { LicencePricingManagement } from "./LicencePricingManagement";

type Tab = "facility" | "doctor";

export const PricingManagement: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<Tab>("facility");

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            {t("admin.pricingManagement.title")}
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            {t("admin.pricingManagement.subtitle")}
          </p>
        </div>
      </div>

      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex gap-6">
          <button
            onClick={() => setActiveTab("facility")}
            className={`pb-3 text-sm font-medium border-b-2 transition-colors ${
              activeTab === "facility"
                ? "border-primary-600 text-primary-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            {t("admin.pricingManagement.tabs.facility")}
          </button>
          <button
            onClick={() => setActiveTab("doctor")}
            className={`pb-3 text-sm font-medium border-b-2 transition-colors ${
              activeTab === "doctor"
                ? "border-primary-600 text-primary-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            {t("admin.pricingManagement.tabs.doctor")}
          </button>
        </nav>
      </div>

      {activeTab === "facility" ? (
        <LicencePricingManagement embedded />
      ) : (
        <DoctorLicencePricingManagement />
      )}
    </div>
  );
};
